import React from 'react';

const ArriveBy = ({ arriveBy }) => (
  <p className="text-color-medium-grey text-size-20 text-weight-book" key="arrive-by-notice">
    Arrive by <span className="important">{arriveBy.format('h:mm' )}</span><span className="less-important">{arriveBy.format('A')}</span>
  </p>
);

export default ArriveBy;
